import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DataList from "../../components/DataList.jsx";
import ModalContainer from "../../components/ModalContainer.jsx";
import { AllProvincesArray } from "../../utils/convertProvince.js";

const UserCompany = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const findProvinceNameByState = (state) => {
    const province = AllProvincesArray.find((prov) => prov.state === state);
    return province ? province.name : "";
  };

  const addressRows = [
    {
        field: "name",
        text: "نام شرکت",
    },
    {
        field: "national_id",
        text: "شناسه ملی",
    },
    {
        field: "registration_number",
        text: "شماره ثبت",
    },
    {
        field: "economic_code",
        text: "کد اقتصادی",
    },
    {
        field: "province",
        text: "استان",
    },
    {
        field: "city",
        text: "شهر",
    },
    {
        field: "registration_phone_number",
        text: "شماره تلفن ثبت",
    },
    {
        field: "registration_address",
        text: "آدرس ثبت",
    },
    {
        field: "SHABA_number",
        text: "شماره شبا (بدون IR)",
    },
  ];

  useEffect(() => {
    if (!location.state) {
      return navigate(-1);
    }
  }, []);

  return (
    <ModalContainer
      alwaysOpen={true}
      fullscreen={false}
      title={`لیست شرکت های کاربر`}
    >
      {location.state?.map((company, index) => (
        <DataList key={index} listData={company} listRowsTitles={addressRows.map(row => {
            if (row.field === "province") {
                return {...row, getValue: () => findProvinceNameByState(company.province)};
            }
            return row;
        })} />
      ))}
    </ModalContainer>
  );
};

export default UserCompany;